import Header from "../components/Header";
import Footer from "../components/Footer";

export default function CorporateCompliance() {
  return (
    <>
      <Header />

      {/* HERO SECTION */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/corpo.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Corporate & ROC Compliances</h1>
          <p>
            End-to-end corporate compliance, ROC filings and secretarial
            services to keep your company compliant and secure.
          </p>
        </div>
      </section>

      {/* OVERVIEW */}
      <section className="container my-5">
        <h2 className="text-center mb-4 fw-bold" style={{ color: "#00385f" }}>
          Overview
        </h2>
        <p className="service-text">
          Every company and LLP in India is required to comply with the
          Companies Act, 2013 and MCA/ROC regulations. At{" "}
          <strong> S D P M & Co. </strong>, we provide end-to-end corporate
          secretarial and compliance services to keep your business legally
          sound and transparent.
        </p>
        <p className="service-text">
          Our qualified Company Secretaries and Chartered Accountants ensure
          that your organization meets every statutory requirement — from
          incorporation to annual filings, board governance, and regulatory
          disclosures.
        </p>
      </section>

      {/* SERVICES SECTION */}
      <section style={{ background: "#f8fafc" }} className="py-5">
        <h2 className="text-center mb-5 fw-bold" style={{ color: "#00385f" }}>
          Our Corporate & MCA Compliance Services
        </h2>
       <div className="container bf-main">
  {/* 1. Incorporation */}
  <div className="bf-card">
    <h3>🏢 Company / LLP Incorporation & Startup Registration</h3>
    <p>
      We manage the complete entity formation process — name
      reservation, SPICe+ filing, PAN/TAN/GST registration, and
      post-incorporation compliance.
    </p>
    <ul>
      <li>Entity structure advice (Private Ltd / LLP / OPC)</li>
      <li>MOA/AOA drafting and e-form submissions</li>
      <li>Startup registration and guidance</li>
    </ul>
  </div>

  {/* 2. ROC Filings */}
  <div className="bf-card">
    <h3>📝 ROC Annual Filings</h3>
    <p>
      We handle complete ROC filing compliance — preparation and
      submission of:
    </p>
    <ul>
      <li>AOC-4 (Financial Statements)</li>
      <li>MGT-7 / MGT-7A (Annual Return)</li>
      <li>ADT-1 (Auditor Appointment)</li>
      <li>DIR-3 KYC (Director KYC Filing)</li>
    </ul>
  </div>

  {/* 3. Registers & Minutes */}
  <div className="bf-card">
    <h3>📚 Maintenance of Statutory Registers & Minutes</h3>
    <p>
      We assist in preparing and maintaining mandatory registers and
      meeting records:
    </p>
    <ul>
      <li>Register of Members, Directors & Shareholders</li>
      <li>Minutes of Board & General Meetings</li>
      <li>Share Transfer & Allotment Registers</li>
    </ul>
  </div>

  {/* 4. Changes in Directors */}
  <div className="bf-card">
    <h3>🔄 Changes in Directors / Office / Capital</h3>
    <p>We manage all event-based filings such as:</p>
    <ul>
      <li>DIR-12 (Director Appointment/Resignation)</li>
      <li>INC-22 (Registered Office Change)</li>
      <li>SH-7, PAS-3 (Capital Changes)</li>
      <li>MOA/AOA & Shareholding Updates</li>
    </ul>
  </div>

  {/* 5. ESOP Advisory */}
  <div className="bf-card">
    <h3>💰 ESOP Advisory & Share Valuation</h3>
    <p>
      We assist with ESOP structuring, valuation, and compliance under
      SEBI and Companies Act provisions.
    </p>
    <ul>
      <li>ESOP policy drafting</li>
      <li>Fair valuation support</li>
      <li>Employee incentive alignment</li>
    </ul>
  </div>

  {/* 6. NGO Compliance */}
  <div className="bf-card">
    <h3>🌱 Section 8 Company & NGO Compliance</h3>
    <p>
      We assist non-profits with incorporation, annual filings, and
      CSR/FCRA advisory.
    </p>
    <ul>
      <li>License renewals and annual returns</li>
      <li>CSR compliance & FCRA support</li>
      <li>Legal and financial governance</li>
    </ul>
  </div>

  {/* 7. Legal Drafting */}
  <div className="bf-card">
    <h3>⚖️ Compounding of Offences & Legal Drafting</h3>
    <p>
      We represent companies before ROC, RD, and NCLT for compounding of
      offences and other legal processes.
    </p>
    <ul>
      <li>Condonation of delay & petitions</li>
      <li>Resolutions, notices, and agreements</li>
      <li>ROC/NCLT representation support</li>
    </ul>
  </div>
</div>

      </section>

      {/* WHY CHOOSE US */}

      {/* <section className="nri-highlight">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <ul>
            <li>
              Dedicated team of Company Secretaries & Chartered Accountants
            </li>
            <li>Comprehensive coverage of ROC & MCA compliances</li>
            <li>On-time filings with zero penalty assurance</li>
            <li>Expertise across startups, LLPs, and NGOs</li>
            <li>Trusted compliance partner for businesses across India</li>
          </ul>
        </div>
      </section> */}

      {/* CTA */}
      {/* <section
        className="py-5 text-white text-center my-5"
        style={{ background: "linear-gradient(90deg, #00385f, #065a8a)" }}
      >
        <div className="container">
          <h3 className="fw-bold mb-3">
            Managing statutory compliance shouldn’t be stressful — it should be
            seamless.
          </h3>
          <p className="mb-4">
            Contact <strong>[S D P M & Co.]</strong> today to streamline your
            ROC filings, company updates, and legal documentation needs.
          </p>

          <Link
            to="/contactus"
            className="apply-btn"
            style={{
              backgroundColor: "#65ad4b",
              color: "#fff",
              borderRadius: "8px",
            }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Contact Us
          </Link>
        </div>
      </section> */}

      <Footer />
    </>
  );
}
